import React from "react";
import IconBack from "../../Resources/svg/Icons/IconBack";

interface INavMobile {
  handleBack: () => void;
  position: number;
  hidden?: boolean;
  subtitle?: string;
  title: string;
  total: number;
}

export const NavFormMobile = ({
  handleBack,
  position,
  hidden,
  subtitle,
  title,
  total,
}: INavMobile) => {
  return (
    <div className="nav-responsive">
      <div className="content-box">
        <div className={`nav-responsive__routing `}>
          <IconBack className="nav-case__back" onClick={handleBack} />
          <>
            <div className="nav-responsive__step">
              Paso {position} de {total}
            </div>
            <progress max="100" value={position * (100 / total)}></progress>
          </>
        </div>
        {hidden !== true && (
          <div className="nav-responsive__subtitle">
            {subtitle ? subtitle : "Realizar cotización"}
          </div>
        )}

        <div className="nav-responsive__title">
          {title ? title : "Datos personales"}
        </div>
      </div>
    </div>
  );
};
